import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-modal-notify-thanks-point-denial" }
const _hoisted_2 = { class: "p-modal-notify-thanks-point-denial__header" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = {
  class: "p-modal-notify-thanks-point-denial__name",
  "data-translate-skip": ""
}
const _hoisted_5 = { class: "p-modal-notify-thanks-point-denial__body" }
const _hoisted_6 = { class: "p-modal-notify-thanks-point-denial__body__list" }
const _hoisted_7 = { class: "p-modal-notify-thanks-point-denial__body__list__item" }
const _hoisted_8 = { class: "p-modal-notify-thanks-point-denial__body__panel" }
const _hoisted_9 = { class: "p-modal-notify-thanks-point-denial__body__panel__text" }
const _hoisted_10 = { class: "p-modal-notify-thanks-point-denial__body__list__item" }
const _hoisted_11 = { class: "p-modal-notify-thanks-point-denial__body__panel" }
const _hoisted_12 = { class: "p-modal-notify-thanks-point-denial__body__panel__text" }
const _hoisted_13 = { "data-translate-skip": "" }
const _hoisted_14 = { class: "p-modal-notify-thanks-point-denial__body__list__item" }
const _hoisted_15 = { class: "p-modal-notify-thanks-point-denial__body__panel" }
const _hoisted_16 = { class: "p-modal-notify-thanks-point-denial__body__panel__text" }
const _hoisted_17 = { "data-translate-skip": "" }
const _hoisted_18 = { class: "p-modal-notify-thanks-point-denial__body__reason" }
const _hoisted_19 = {
  class: "p-modal-notify-thanks-point-denial__body__reason__text",
  "data-translate-skip": ""
}
const _hoisted_20 = { class: "p-modal-notify-thanks-point-denial__footer" }
const _hoisted_21 = { class: "p-modal-notify-thanks-point-denial__footer__item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconUserImage = _resolveComponent("IconUserImage")!
  const _component_SmallText = _resolveComponent("SmallText")!
  const _component_ButtonMain = _resolveComponent("ButtonMain")!
  const _component_modal_main = _resolveComponent("modal-main")!

  return (_openBlock(), _createBlock(_component_modal_main, null, {
    fullBody: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_IconUserImage, { size: _ctx.profileIconSize }, {
            default: _withCtx(() => [
              (_ctx.user.user_image)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: "p-modal-notify-thanks-point-denial__avatar",
                    src: _ctx.user.user_image,
                    alt: _ctx.user.user_name
                  }, null, 8, _hoisted_3))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["size"]),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.user.user_name), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("ul", _hoisted_6, [
            _createElementVNode("li", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_SmallText, { size: 14 }, {
                  default: _withCtx(() => _cache[0] || (_cache[0] = [
                    _createTextVNode("送付ポイント", -1)
                  ])),
                  _: 1,
                  __: [0]
                }),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.transaction.points), 1)
                ])
              ])
            ]),
            _createElementVNode("li", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_SmallText, { size: 14 }, {
                  default: _withCtx(() => _cache[1] || (_cache[1] = [
                    _createTextVNode("タイトル", -1)
                  ])),
                  _: 1,
                  __: [1]
                }),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.title), 1)
                ])
              ])
            ]),
            _createElementVNode("li", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_SmallText, { size: 14 }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createTextVNode("本文", -1)
                  ])),
                  _: 1,
                  __: [2]
                }),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.message), 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_SmallText, { size: 14 }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createTextVNode("否認理由", -1)
              ])),
              _: 1,
              __: [3]
            }),
            _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.approverComment), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_ButtonMain, {
              kind: "cancel",
              onClickButton: _ctx.closeModal
            }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createTextVNode(" 閉じる ", -1)
              ])),
              _: 1,
              __: [4]
            }, 8, ["onClickButton"])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}